import { render, staticRenderFns } from "./OnboardingLayout.vue?vue&type=template&id=3aa0fa88&scoped=true"
import script from "./OnboardingLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingLayout.vue?vue&type=script&lang=js"
import style0 from "./OnboardingLayout.vue?vue&type=style&index=0&id=3aa0fa88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0fa88",
  null
  
)

export default component.exports